module.exports = __webpack_public_path__ + "static/media/1.d193c84b.svg";